import { render, staticRenderFns } from "./WallPostListItem.vue?vue&type=template&id=940200ba&scoped=true&"
import script from "./WallPostListItem.vue?vue&type=script&lang=js&"
export * from "./WallPostListItem.vue?vue&type=script&lang=js&"
import style0 from "./WallPostListItem.vue?vue&type=style&index=0&id=940200ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940200ba",
  null
  
)

export default component.exports